const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const twoDp = (value, padded, commas) => {
  const base = '' + Math.round(value * 100) / 100
  if(!padded) return base
  if(base.indexOf('.') < 0) {
    const int = commas ? numberWithCommas(base) : base
    return int + '.00'
  }
  else {
    let [ int, float ] = base.split('.')
    int = commas ? numberWithCommas(int) : int
    let ret = int + '.' + float
    return float.length == 1 ?
      ret + '0' :
      ret
  }
}

const twoDpRaw = (value) => parseFloat(twoDp(value))

module.exports = {
  twoDp,
  twoDpRaw,
}